import { render, staticRenderFns } from "./FaqConflictedColumn.vue?vue&type=template&id=707d2471&scoped=true&"
import script from "./FaqConflictedColumn.vue?vue&type=script&lang=js&"
export * from "./FaqConflictedColumn.vue?vue&type=script&lang=js&"
import style0 from "./FaqConflictedColumn.vue?vue&type=style&index=0&id=707d2471&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d2471",
  null
  
)

export default component.exports